const MBN = "MBN";
export const mapMBNMarketIcon = (isMBNEnabled, market) => {
    if (!isMBNEnabled) {
        market.mbnIcon = { active: false, tagNumber: 0 };
        return market;
    }
    const mbnTag = market.tags.find(tag => tag.startsWith(MBN));
    market.mbnIcon = {
        active: !market.isEmpty,
        tagNumber: mbnTag ? getMBNTagNumber(mbnTag) : 1
    };
    return market;
};
const getMBNTagNumber = (tag) => {
    return parseInt(tag.replace(MBN, "")) || 1;
};
//# sourceMappingURL=mapMBNMarketIcon.js.map